// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_teaming_agreements.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * SAD-494 TEAM-02: workshare and agreement lifecycle for shortlisted or
 * selected teaming candidates. All history is append-only with actor and time.
 * An agreement can only become `executed` with a human's linked evidence and
 * attestation; the server enforces it and no task or AI path reaches it.
 *
 * @generated from message mono.projectdata.v1.CaptureTeamingWorkshare
 */ export class CaptureTeamingWorkshare extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTeamingWorkshare().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTeamingWorkshare().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTeamingWorkshare().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTeamingWorkshare, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string candidate_id = 2;
   */ _define_property(this, "candidateId", ""), /**
   * Work area the partner is planned to carry.
   *
   * @generated from field: string area = 3;
   */ _define_property(this, "area", ""), /**
   * Planned share of the whole effort, 0-100.
   *
   * @generated from field: double planned_share_pct = 4;
   */ _define_property(this, "plannedSharePct", 0), /**
   * @generated from field: string scope = 5;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string notes = 6;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string actor_user_id = 7;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp at = 8;
   */ _define_property(this, "at", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTeamingWorkshare, "runtime", proto3);
_define_property(CaptureTeamingWorkshare, "typeName", "mono.projectdata.v1.CaptureTeamingWorkshare");
_define_property(CaptureTeamingWorkshare, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "planned_share_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureTeamingAgreementEvent
 */ export class CaptureTeamingAgreementEvent extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTeamingAgreementEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTeamingAgreementEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTeamingAgreementEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTeamingAgreementEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * draft | in_negotiation | executed | withdrawn
   *
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string note = 3;
   */ _define_property(this, "note", ""), /**
   * Executed only: the linked document.
   *
   * @generated from field: string evidence_label = 4;
   */ _define_property(this, "evidenceLabel", ""), /**
   * @generated from field: string evidence_ref = 5;
   */ _define_property(this, "evidenceRef", ""), /**
   * Executed only: the human who attested, and their statement.
   *
   * @generated from field: string attested_by = 6;
   */ _define_property(this, "attestedBy", ""), /**
   * @generated from field: string attestation = 7;
   */ _define_property(this, "attestation", ""), /**
   * @generated from field: string actor_user_id = 8;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp at = 9;
   */ _define_property(this, "at", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTeamingAgreementEvent, "runtime", proto3);
_define_property(CaptureTeamingAgreementEvent, "typeName", "mono.projectdata.v1.CaptureTeamingAgreementEvent");
_define_property(CaptureTeamingAgreementEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "evidence_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "evidence_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "attested_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "attestation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureTeamingAgreement
 */ export class CaptureTeamingAgreement extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTeamingAgreement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTeamingAgreement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTeamingAgreement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTeamingAgreement, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string candidate_id = 2;
   */ _define_property(this, "candidateId", ""), /**
   * nda | ta | subcontract
   *
   * @generated from field: string agreement_type = 3;
   */ _define_property(this, "agreementType", ""), /**
   * @generated from field: string actor_user_id = 4;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0), /**
   * Latest event state.
   *
   * @generated from field: string state = 6;
   */ _define_property(this, "state", ""), /**
   * Newest first. Retained in full.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureTeamingAgreementEvent history = 7;
   */ _define_property(this, "history", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTeamingAgreement, "runtime", proto3);
_define_property(CaptureTeamingAgreement, "typeName", "mono.projectdata.v1.CaptureTeamingAgreement");
_define_property(CaptureTeamingAgreement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "agreement_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "history",
            kind: "message",
            T: CaptureTeamingAgreementEvent,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureTeamingAgreementsRequest
 */ export class GetCaptureTeamingAgreementsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureTeamingAgreementsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureTeamingAgreementsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureTeamingAgreementsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureTeamingAgreementsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureTeamingAgreementsRequest, "runtime", proto3);
_define_property(GetCaptureTeamingAgreementsRequest, "typeName", "mono.projectdata.v1.GetCaptureTeamingAgreementsRequest");
_define_property(GetCaptureTeamingAgreementsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureTeamingAgreementsResponse
 */ export class GetCaptureTeamingAgreementsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureTeamingAgreementsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureTeamingAgreementsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureTeamingAgreementsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureTeamingAgreementsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Every workshare entry, newest first; the latest per candidate+area is current.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureTeamingWorkshare workshare = 1;
   */ _define_property(this, "workshare", []), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureTeamingAgreement agreements = 2;
   */ _define_property(this, "agreements", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureTeamingAgreementsResponse, "runtime", proto3);
_define_property(GetCaptureTeamingAgreementsResponse, "typeName", "mono.projectdata.v1.GetCaptureTeamingAgreementsResponse");
_define_property(GetCaptureTeamingAgreementsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workshare",
            kind: "message",
            T: CaptureTeamingWorkshare,
            repeated: true
        },
        {
            no: 2,
            name: "agreements",
            kind: "message",
            T: CaptureTeamingAgreement,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureTeamingWorkshareRequest
 */ export class AddCaptureTeamingWorkshareRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureTeamingWorkshareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureTeamingWorkshareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureTeamingWorkshareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureTeamingWorkshareRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string candidate_id = 4;
   */ _define_property(this, "candidateId", ""), /**
   * @generated from field: string area = 5;
   */ _define_property(this, "area", ""), /**
   * @generated from field: double planned_share_pct = 6;
   */ _define_property(this, "plannedSharePct", 0), /**
   * @generated from field: string scope = 7;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string notes = 8;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureTeamingWorkshareRequest, "runtime", proto3);
_define_property(AddCaptureTeamingWorkshareRequest, "typeName", "mono.projectdata.v1.AddCaptureTeamingWorkshareRequest");
_define_property(AddCaptureTeamingWorkshareRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "planned_share_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureTeamingWorkshareResponse
 */ export class AddCaptureTeamingWorkshareResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureTeamingWorkshareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureTeamingWorkshareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureTeamingWorkshareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureTeamingWorkshareResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamingWorkshare workshare = 1;
   */ _define_property(this, "workshare", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureTeamingWorkshareResponse, "runtime", proto3);
_define_property(AddCaptureTeamingWorkshareResponse, "typeName", "mono.projectdata.v1.AddCaptureTeamingWorkshareResponse");
_define_property(AddCaptureTeamingWorkshareResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workshare",
            kind: "message",
            T: CaptureTeamingWorkshare
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureTeamingAgreementRequest
 */ export class CreateCaptureTeamingAgreementRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureTeamingAgreementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureTeamingAgreementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureTeamingAgreementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureTeamingAgreementRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string candidate_id = 4;
   */ _define_property(this, "candidateId", ""), /**
   * @generated from field: string agreement_type = 5;
   */ _define_property(this, "agreementType", ""), /**
   * @generated from field: string note = 6;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureTeamingAgreementRequest, "runtime", proto3);
_define_property(CreateCaptureTeamingAgreementRequest, "typeName", "mono.projectdata.v1.CreateCaptureTeamingAgreementRequest");
_define_property(CreateCaptureTeamingAgreementRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "agreement_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureTeamingAgreementResponse
 */ export class CreateCaptureTeamingAgreementResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureTeamingAgreementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureTeamingAgreementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureTeamingAgreementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureTeamingAgreementResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamingAgreement agreement = 1;
   */ _define_property(this, "agreement", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureTeamingAgreementResponse, "runtime", proto3);
_define_property(CreateCaptureTeamingAgreementResponse, "typeName", "mono.projectdata.v1.CreateCaptureTeamingAgreementResponse");
_define_property(CreateCaptureTeamingAgreementResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "agreement",
            kind: "message",
            T: CaptureTeamingAgreement
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetCaptureTeamingAgreementStateRequest
 */ export class SetCaptureTeamingAgreementStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTeamingAgreementStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTeamingAgreementStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTeamingAgreementStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTeamingAgreementStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string agreement_id = 4;
   */ _define_property(this, "agreementId", ""), /**
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string note = 6;
   */ _define_property(this, "note", ""), /**
   * executed only: linked document and the caller's explicit attestation.
   *
   * @generated from field: string evidence_label = 7;
   */ _define_property(this, "evidenceLabel", ""), /**
   * @generated from field: string evidence_ref = 8;
   */ _define_property(this, "evidenceRef", ""), /**
   * @generated from field: bool attest = 9;
   */ _define_property(this, "attest", false), /**
   * @generated from field: string attestation = 10;
   */ _define_property(this, "attestation", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTeamingAgreementStateRequest, "runtime", proto3);
_define_property(SetCaptureTeamingAgreementStateRequest, "typeName", "mono.projectdata.v1.SetCaptureTeamingAgreementStateRequest");
_define_property(SetCaptureTeamingAgreementStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "agreement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "evidence_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "evidence_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "attest",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "attestation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetCaptureTeamingAgreementStateResponse
 */ export class SetCaptureTeamingAgreementStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTeamingAgreementStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTeamingAgreementStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTeamingAgreementStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTeamingAgreementStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamingAgreement agreement = 1;
   */ _define_property(this, "agreement", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTeamingAgreementStateResponse, "runtime", proto3);
_define_property(SetCaptureTeamingAgreementStateResponse, "typeName", "mono.projectdata.v1.SetCaptureTeamingAgreementStateResponse");
_define_property(SetCaptureTeamingAgreementStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "agreement",
            kind: "message",
            T: CaptureTeamingAgreement
        }
    ]));
